require('./pc.scss');
require('module/m_advert/index');



// WEBPACK FOOTER //
// ./jws/views/page/m_gdvert/pc.js